<template>
  <div class="px-2 flex flex-row gap-2">
      <!-- Before -->
    <slot name="before"/>
    <!-- normal: grid with generous spacing; reduced: tight columns touching center -->
    <div
        class="items-center flex-1 min-w-0"
        :class="reduced
        ? 'grid grid-cols-[1fr_auto_1fr] gap-1'
        : 'grid grid-cols-[1fr_auto_1fr] gap-4'"
    >
      <!-- LEFT side -->

      <div class="flex items-center min-w-0">

        <!-- label/date placement switches with reduced -->
        <div v-if="initial" class="shrink-0" :class="reduced ? 'text-left' : 'text-center'">
            <div class="flex items-center gap-1 px-2">
              <span v-if="initialKind" class="text-base leading-none shrink-0 self-center pe-2">{{ locationTypeFromCode(initialKind) }}</span>
              <div class="flex flex-col">
                <div class="text-sm text-primary font-bold">{{ initial }}</div>
                <div class="text-[11px] text-light">{{ initialLabel }}</div>
              </div>
            </div>
        </div>

        <!-- segment: in reduced, no dots + right triangle to dock to center -->
        <FlightSegment
          class="flex-1 min-w-4"
          :colorClass="color"
          :showRightDot="!reduced"
          :showLeftDot="!reduced"
          :rightCap="reduced"
          wide
        />
      </div>

      <!-- CENTER icon -->
      <div class="justify-self-center">
        <!-- caller can still pass a slot; in reduced you likely pass icon only -->
        <slot/>
      </div>

      <!-- RIGHT side -->
      <div class="flex items-center min-w-0 justify-end">
        <!-- segment: in reduced, no dots + left triangle to dock to center -->
        <FlightSegment
          class="flex-1 min-w-4"
          :colorClass="color"
          :showLeftDot="!reduced"
          :showRightDot="!reduced"
          :leftCap="reduced"
          wide
        />
        <div v-if="final" class="shrink-0" :class="reduced ? 'text-right' : 'text-center'">
            <div class="flex items-center gap-1 px-2">
              <div class="flex flex-col text-right">
                <div class="text-sm text-primary font-bold">{{ final }}</div>
                <div class="text-[11px] text-light">{{ finalLabel }}</div>
              </div>
              <span v-if="finalKind" class="text-base leading-none shrink-0 self-center ps-2">{{ locationTypeFromCode(finalKind) }}</span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import FlightSegment from '@/components/atoms/FlightSegment.vue'
import {computed} from 'vue'
import {getFlightStatusColor, getRequestStatusColor, locationTypeFromCode} from '@/common/functions.js'

const props = defineProps({
  initial: String,
  initialLabel: { type: String, default: 'Departure' },
  final: String,
  finalLabel: { type: String, default: 'Arrival' },
  status: String,
  color: String,
  initialKind: { type: String, default: null },
  finalKind: { type: String, default: null },
  reduced: { type: Boolean, default: false },
  isRequest: { type: Boolean, default: false },
})

const color = computed(() => {
  if (props.color) return props.color
  return props.isRequest
    ? getRequestStatusColor(props.status)
    : getFlightStatusColor(props.status)
})
</script>